"use strict";

import Dom from "common/Dom";
import * as handlers from "./handlers";
export const bindActions = function bindActions() {
  $(Dom.variantSelect).on("change", function (event) {
    handlers.updatePrice($(this));
    handlers.updateVariantSubheader($(this));
    handlers.updateVariantImage($(this));
    handlers.updateVariantDescription($(this));
  });
};
